import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from '../modal/modal.module';

import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';

import { AutocompleteComponent } from './autocomplete.component';
import { AutocompleteRoutingModule } from './autocomplete.routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AutocompleteRoutingModule,
    ReactiveFormsModule
  ],
  exports: [
    AutocompleteComponent
  ],
  declarations: [
    AutocompleteComponent
  ],
  providers: [
    GenericdatasetService
  ]
})
export class AutocompleteModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AutocompleteModule,
      providers: [GenericdatasetService]
    };
  }
}
